import type { CustomCellEditorProps } from '../react.js';
import { useState } from 'react';

import { CalendarSingle, type Matcher } from '@mint-lib/tw-components/patterns';
import { format, parse } from 'date-fns';

export interface DateISOEditorProps extends CustomCellEditorProps {
  disabledDates?: Matcher | Matcher[];
  defaultMonth?: Date;
}

const ISO_DATE_FORMAT = 'yyyy-MM-dd';

export const DateISOEditor = (props: DateISOEditorProps) => {
  const [selectedDate, setSelectedDate] = useState<Date | undefined>(
    props.value ? parse(props.value, ISO_DATE_FORMAT, new Date()) : undefined,
  );

  const handleDateApply = (date?: Date) => {
    props.onValueChange(date ? format(date, ISO_DATE_FORMAT) : undefined);
    props.api.stopEditing();
  };

  return (
    // The `translate-0` class is needed to fix the position of the calendar popup inside the grid. Without it, the popup will be cut off or positioned incorrectly.
    <div className="translate-0" data-dd-action-name="Grid cell: edit date">
      <CalendarSingle
        selected={selectedDate}
        onSelect={setSelectedDate}
        onApply={handleDateApply}
        disabledDates={props.disabledDates}
        defaultMonth={props.defaultMonth}
      />
    </div>
  );
};
